export default __webpack_public_path__ + "static/media/promo_04.a4b7bb3e.jpg";